import { createGlobalStyle } from 'styled-components';
import {
  SecondaryBgColor, primaryHeadingColor, secondaryFont,
  wMedium, primaryFont, minWidthApp,
  wMBold,
} from '../Utils/utilsStyle';

const CompanyStyle = createGlobalStyle`
.cursor-pointer{
  cursor: pointer;
}
.tabsAppend {
  @media all and (max-width:${minWidthApp}){
    .header-wrapper {
      .left-side-wrap {
        .heading {
          white-space: unset;
        }
      }
      .right-side-wrap {
        .showTabs {
          .tabs-item {
            margin-right: 5px !important;
            padding: 7px 7px !important;
          }
        }
      }
    }
  }
}
.container-company-card{
  border-radius:16px;
  background-color:${SecondaryBgColor};
  padding: 0px 0px 30px 0px;
  .teams-share-button {
    a[target="ms-teams-share-popup"] {
      img {
        width: 18px;
        margin-right: 5px;
        margin-left: -2px;
      }
    }
  }
}
.download-profile-popover{
  .ant-popover-arrow{
    width: 16px;
    height: 16px;
    .ant-popover-arrow-content{
      width: 16px;
      height: 16px;
      &:hover{
        width: 16px;
        height: 16px;
      }
    }
  }
  .ant-popover-inner{
    border-radius:12px;
    padding: 0px;
    .profile-dropdown{
      padding:16px;
      background-color:#FFFFFF;
      border-radius:12px;
      h3{
        display: flex;
        align-items: center;
        color:${primaryHeadingColor};
        font-family:${secondaryFont};
        font-weight:${wMedium};
        font-size:28px;
        margin:0 0 11px 0;
        svg{
          height: 24px;
          width: 24px;
          path{fill:#000;}
        }
      }
      .ant-col {
        > div{
          border-radius:8px;
          background-color:#F5F5F5;
          text-align:center;
          padding:24px 12px 20px 12px;
          margin:0 3px;
          height:100%;
          display: flex;
          flex-direction: column;
          
          h4{
            margin:14px 0 0 6px;
            font-size:18px;
            color:${primaryHeadingColor};
            font-family:${secondaryFont};
            font-weight:${wMBold};
            text-align:left;
          }
          ul{
            margin:0 0 12px 6px;
            padding:0;
            list-style-position: inside;
            li{
              text-align:left;
              color:#7E7E7E;
              font-size:11px;
              font-family:${primaryFont};
              font-weight:${wMedium};
              margin:0;
              padding:0;
            }
          }
          button{
            margin:auto 0 0 0;
          }
        }
      }
    }
}
}
.sub-header-main-wrapper {
  .sub-header-wrapper {
    .heading-inner-page {
      .tips-placeholder {
        @media all and (max-width: ${minWidthApp}){
          margin-left: 0px;
        }
      }
    }
  }
}
`;

export default CompanyStyle;
